import { HiMenu } from "react-icons/hi"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import Button from "../button"
import ProductsDropdown from "../navbar-dropdown"
import SolutionsDropdown from "../navbar-dropdown/SolutionsDropdown"
import MobileNav from "../mobile-nav"

const Navbar = ({ NavbarData,params}) => {
  const [isExpanded, toggleExpansion] = useState(false)
  const [scrollNav, setScrollNav] = useState(false)
  const { atlasOneLogo, headerButtons, headerMenuItems } = NavbarData
  const [hoveredItem, setHoveredItem] = useState("")
  const changeNav = () => {
    if (window.scrollY > 78 && window.innerWidth > 450) {
      setScrollNav(true)
    } else if (window.innerWidth > 450 && (window.scrollY === 30 || window.scrollY === 0)){
      setScrollNav(false)
    }else if (window.innerWidth < 450 && window.scrollY > 63){
      setScrollNav(true)
    }
  }
  const getSrcSet = (src) => {
    const ratioArry = [1, 1.5, 2, 3]
    let srcSet = ""
    const width = 200
    ratioArry.forEach(ratio => srcSet += `${src}?w=${width * ratio} ${ratio}x, `)
    return srcSet
  }

  useEffect(() => {
    window.addEventListener("scroll", changeNav)
  }, [])

  return (
    <nav
      className={`w-screen h-[60px] md:h-[88px]  px-5 md:px-10 xl1:px-40  z-20 top-0  whitespace-nowrap
      ${scrollNav === true ?  " sticky  scrollNav-underline bg-black" :  " md:h-[90px] md:pt-[20px]"}
      `}>
      <div className="flex items-center justify-between w-full h-full max-w-screen-xl mx-auto ">
        <div className="md:z-50">
          <Link to={`/${params ? `${params}`: ""}`}>
            <img
              className="navbar logo"
              srcSet={getSrcSet(atlasOneLogo?.image.file.url)}
              alt=""
            />
          </Link>
        </div>
        {/* Desktop Version */}
        <div className="flex-[0.9] navbar-hide">
          <ul className="flex items-center justify-end">
            {
              headerMenuItems?.map((headerMenuItem, index) => {
                if (headerMenuItem?.headerMenuDropdown?.[0]?.items.length > 1 && headerMenuItem.title !== "Solutions"){
                  return (
                    <li
                      key={`header-menu-item-${index}`}
                      className={`md:z-50 mt-2 py-8 text-ats font-medium uppercase cursor-pointer Figtree-Medium group navbar-border-bottom mx-[20px] navbar-item-anim tracking-widest  duration-300 ease-animationAts delay-0   
                      ${hoveredItem === headerMenuItem.title || hoveredItem === ""
                          ? "text-ProjectBlack"
                          : "text-[#FFFFFF80]"
                        }`}
                      onMouseOver={() => setHoveredItem(headerMenuItem.title)}
                      onFocus={() => setHoveredItem(headerMenuItem.title)}
                      onClick={() => setHoveredItem(headerMenuItem.title)}
                      onMouseOut={() => setHoveredItem("")}
                      onBlur={() => setHoveredItem("")}
                      role="presentation"
                    >
                      {headerMenuItem.title}
                      <div className={`  relative top-9 z-99 transition-all duration-75 ease delay-0 
                        ${hoveredItem === headerMenuItem.title ? " visible" : " invisible"
                        }`}
                      >
                        <ProductsDropdown
                          DropdownData={headerMenuItem?.headerMenuDropdown?.[0]?.items}
                          params= {params}
                        />
                      </div>
                    </li>
                  )
                }
                else if(headerMenuItem?.headerMenuDropdown?.[0]?.items.length > 1 && headerMenuItem.title === "Solutions"){
                  return (
                    <li
                    key={`header-menu-item-${index}`}
                      className={`md:z-50 mt-2 py-8 text-ats font-medium uppercase cursor-pointer Figtree-Medium group navbar-border-bottom mx-[20px] navbar-item-anim tracking-widest  duration-300 ease-animationAts delay-0    
                      ${hoveredItem === headerMenuItem.title || hoveredItem === ""
                        ? "text-ProjectBlack"
                        : "text-[#FFFFFF80]"
                        }`}
                      onMouseOver={() => setHoveredItem(headerMenuItem.title)}
                      onFocus={() => setHoveredItem(headerMenuItem.title)}
                      onClick={() => setHoveredItem(headerMenuItem.title)}
                      onMouseOut = {() => setHoveredItem("")}
                      onBlur = {() => setHoveredItem("")}
                      role="presentation"
                    >
                      {headerMenuItem.title}
                      <div className={` relative top-9 z-99 transition-all duration-75 ease delay-0 
                        ${hoveredItem === headerMenuItem.title ? " visible" : " invisible"
                        }`}
                      >
                        <SolutionsDropdown
                          DropdownData1={headerMenuItem.headerMenuDropdown?.[0]?.items}
                          DropdownData3={headerMenuItem.headerMenuDropdown?.[1]?.items}
                        />
                      </div>
                    </li>
                  )
                }
                else
                  return (
                    <li
                      key={`header-menu-item-${index}`}
                      className={`md:z-50 mt-2 py-8 text-ats font-medium uppercase cursor-pointer Figtree-Medium group navbar-border-bottom mx-[20px] navbar-item-anim tracking-widest  duration-300 ease-animationAts delay-0   
                      ${hoveredItem === headerMenuItem.title || hoveredItem === ""
                          ? "text-ProjectBlack"
                          : "text-[#FFFFFF80]"
                      }`}
                      onMouseOver={() => setHoveredItem(headerMenuItem.title)}
                      onFocus={() => setHoveredItem(headerMenuItem.title)}
                      onClick={() => setHoveredItem(headerMenuItem.title)}
                      onMouseOut={() => setHoveredItem("")}
                      onBlur={() => setHoveredItem("")}
                      role="presentation"
                    >
                      <Link to={ `/${headerMenuItem?.headerMenuDropdown?.[0]?.items?.[0].page.slug}${params  ? `${params}` :""}` || `/${headerMenuItem?.headerMenuDropdown?.[0]?.items?.[0].replace(/\s+/g, '-').toLowerCase()}${params ? `${params}` :""}`}
                      > 
                        {headerMenuItem.title}
                      </Link>
                    </li>
                  )
              })
            }

            <div className="flex items-center ml-[8px]  md:z-50">
              {headerButtons?.map((buttonData, index) => (
                <li key={index} className={index === headerButtons.length - 1 ? "ml-[8px]" : "mx-[8px]"}>
                  <Button
                    link={`${buttonData?.url}${params ? `${params}`: ""}`}
                    title={buttonData.title}
                    variant={buttonData.elementType === "primaryButton" || (buttonData.elementType == null && index === headerButtons.length - 1) ? "primary" : "secondary"}
                    theme={buttonData.theme[0].toLowerCase()}
                  />
                </li>
              ))}
            </div>
          </ul>
        </div>
        {/* Mobile Version */}
        <div className="navbar-menu-hide">
          {headerMenuItems?.length > 0 && <HiMenu
            className="cursor-pointer text-ProjectBlack"
            onClick={() => toggleExpansion(!isExpanded)}
            fontSize={30}
          />}
          {isExpanded && (
            <MobileNav
              toggleExpansion={toggleExpansion}
              isExpanded={isExpanded}
              logo={atlasOneLogo.image}
              sidebarFirstMenuData={headerMenuItems}
              headerButtons={headerButtons}
            />
          )}
        </div>
      </div>
    </nav>
  )
}

Navbar.propTypes = {
  variant: PropTypes.string,
}

export default Navbar
